module.exports = __webpack_public_path__ + "static/albedo-banner-eb3d01cb0403fa22de340ad7bdf59756.png";